import React from 'react';
const Hero = () => {
    return (
        <>
            <div class="hero-bg">
                <h1>Welcome to Tailor Bird</h1>
                <h3>Discover true personalization</h3>
            </div>
        </>
    )
}
export default Hero;